import { SDLUtil, RequestUtil } from '@/utils';

const setWeekChange = ({ commit }, data) => {
  commit('GET_ACCESS_KEY_SUMMARY_WEEK_CHANGE', data);
};

const setLastSummary = ({ commit }, data) => {
  commit('GET_ACCESS_KEY_SUMMARY_LAST_SUMMARY', data);
};
const setExceptCnt = ({ commit }, data) => {
  commit('GET_ACCESS_KEY_SUMMARY_EXCEPT_CNT', data);
};
const setD1Cnt = ({ commit }, data) => {
  commit('GET_ACCESS_KEY_SUMMARY_D1_CNT', data);
};

export default {
  async GET_ACCESS_KEY_SUMMARY_WEEK_CHANGE(store) {
    const data = await RequestUtil.get(`${SDLUtil.API_URL}/accesskey/summary/list-week-change`);
    setWeekChange(store, data.data);
  },
  async GET_ACCESS_KEY_SUMMARY_LAST_SUMMARY(store) {
    const data = await RequestUtil.get(`${SDLUtil.API_URL}/accesskey/summary/select-last-summary`);
    setLastSummary(store, data.data);
  },
  async GET_ACCESS_KEY_SUMMARY_EXCEPT_CNT(store) {
    const data = await RequestUtil.get(`${SDLUtil.API_URL}/accesskey/summary/select-except-cnt`);
    setExceptCnt(store, data.data);
  },
  async GET_ACCESS_KEY_SUMMARY_D1_CNT(store) {
    const data = await RequestUtil.get(`${SDLUtil.API_URL}/accesskey/summary/select-d1-cnt`);
    setD1Cnt(store, data.data);
  },
};



// WEBPACK FOOTER //
// ./src/vuex/accKey/summary/accKeySummaryAction.js